import type { PhotoCategory } from "@/api/hooks/use-photo-categories";

/** Detection kinds (mirror of the backend PhotoDetection enum — the values
 *  live in photo_categories.detection, seeded by scripts/seed_photo_categories
 *  and the f7b2d9c4a8e1 migration). */
export const OIL_TANK_VOL_DETECTION = "oil_tank_vol";
export const scaleSetDetection = (setIndex: number) => `scale_set_${setIndex}`;

/** Leaf categories carrying a detection flag, keyed by detection kind.
 *  The seeds bind each kind to exactly one category; if an admin ever flags a
 *  second one, first-in-tree-order wins and we warn instead of guessing
 *  silently. */
export function detectionCategories(
  categories: PhotoCategory[] | undefined,
): Map<string, PhotoCategory> {
  const byKind = new Map<string, PhotoCategory>();
  for (const cat of flattenCategories(categories ?? [])) {
    if (!cat.detection) continue;
    if (byKind.has(cat.detection)) {
      console.warn(
        `Multiple photo categories carry detection "${cat.detection}" — using "${byKind.get(cat.detection)?.name}", ignoring "${cat.name}"`,
      );
      continue;
    }
    byKind.set(cat.detection, cat);
  }
  return byKind;
}

export function flattenCategories(categories: PhotoCategory[]): PhotoCategory[] {
  const result: PhotoCategory[] = [];
  for (const cat of categories) {
    if (cat.children && cat.children.length > 0) {
      result.push(...flattenCategories(cat.children));
    } else {
      result.push(cat);
    }
  }
  return result;
}

// LOAD-BEARING convention: the weighing photo subtree is identified by this
// root category NAME. Also relied on by backend/scripts/seed_photo_categories.py
// and the photo-ownership migration (alembic h2c9d4e6f8a1) — renaming the
// category in the admin UI changes what all three treat as weighing photos.
const WEIGHING_ROOT_NAME = "Weighing";

export function getWeighingSections(allCategories: PhotoCategory[] | undefined): PhotoCategory[] {
  const root = allCategories?.find((r) => r.name === WEIGHING_ROOT_NAME);
  return root?.children ?? [];
}
